(function() {
    'use strict';

    window.addEventListener('load', function() {
        if (typeof Swiper === 'undefined') {
            return;
        }

        var galleries = document.querySelectorAll('.b-gallery');

        if (galleries.length === 0) {
            return;
        }

        galleries.forEach(function(gallery) {
            var mainElement = gallery.querySelector('.b-gallery__slider-main');
            var thumbsElement = gallery.querySelector('.b-gallery__slider-thumbs');
            var nextButton = gallery.querySelector('.swiper-button-next');
            var prevButton = gallery.querySelector('.swiper-button-prev');

            if (!mainElement || !thumbsElement) {
                return;
            }

            var thumbsSwiper = new Swiper(thumbsElement, {
                direction: 'vertical',
                spaceBetween: 10,
                slidesPerView: 3,
                slidesPerGroup: 1,
                freeMode: true,
                watchSlidesProgress: true,
                mousewheel: true,
            });

            new Swiper(mainElement, {
                spaceBetween: 10,
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                },
                thumbs: {
                    swiper: thumbsSwiper,
                },
            });
        });
    });

})();